/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsCompany } from "../../entities/models/Company";
import { z } from "zod/v4";

export const modelsCompanySchema = z.object({
    "address": z.optional(z.string()),
"created_at": z.optional(z.string()),
"currency": z.optional(z.string()),
"deleted_at": z.optional(z.string()),
"id": z.optional(z.int()),
"info": z.optional(z.object({
    
    }).catchall(z.any())),
"inn": z.optional(z.string()),
"kpp": z.optional(z.string()),
"name": z.optional(z.string()),
"phone": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsCompany>